import template from './category.html';
import controller from './category.controller';
import './category.scss';

const categoryComponent = {
  bindings: {},
  template,
  controller,
};

export default categoryComponent;



// WEBPACK FOOTER //
// ./client/app/components/category/category.component.js